module.exports = __webpack_public_path__ + "static/media/replacement2x.a2db83c1.webp";